import Environment from './Environment';
import BaseApi from './BaseApi';

class UsersApi extends BaseApi {
  constructor() {
    super();
    this.url = Environment.alulaApi;
    this.path = 'v1/users';
  }
}

export default new UsersApi();



// WEBPACK FOOTER //
// ./src/api/UsersApi.js